import axios from '../request';

export default {
  /**
   * 钢筋需求计划模块接口
  */

  // 查询钢筋需求计划列表信息
  searchRebardemandList: (params) =>
    axios.post('/materials/needYear/needYearList', params),
  // 添加钢筋需求计划信息
  insertRebardemandInfo: (params) =>
    axios.post('/materials/needYear/needYearInsert', params),
  // 修改钢筋需求计划信息
  updateRebardemandInfo: (params) =>
    axios.post('/materials/needYear/needYearUpdate', params),
  // 删除钢筋需求计划信息
  deleteRebardemandInfo: (params) =>
    axios.get('/materials/needYear/needYearDel', {params}),
  // 获取钢筋需求计划详情信息
  getRebardemandInfo: (params) =>
    axios.get('/materials/needYear/needYearInfo', {params}),

  /**
   * 钢筋理论耗量模块接口
  */

  // 获取表头信息
  getTableTitleInfo: () => 
    axios.get('/materials/steel/steelPull'),
  // 查询钢筋理论耗材列表信息
  searchRebartheoryList: (params) =>
    axios.post('/materials/consumption/consumptionList', params),
  // 添加钢筋理论耗材信息
  insetRebartheoryInfo: (params) =>
    axios.post('/materials/consumption/consumptionInsert', params),
  // 修改钢筋理论耗材信息
  updateRebartheoryList: (params) =>
    axios.post('/materials/consumption/consumptionUpdate', params),
  // 删除钢筋理论耗材信息
  deleteRebartheoryList: (params) =>
    axios.get('/materials/consumption/consumptionDel', {params}),
  // 获取钢筋理论耗材信息详情
  getRebartheoryInfoData: (params) =>
    axios.get('/materials/consumption/consumptionInfo', {params}),
  // 导出钢筋理论耗量Excel
  exportRebartheoryExcel: (params) =>
    axios({
      method: 'post',
      url: '/materials/consumption/consumptionExcel',
      responseType: 'blob',
      data: params
    }),
}